<template>
  <div class="pagination">
    <a-pagination
        v-model:current="current"
        v-model:pageSize="size"
        :total="count"
        :showTotal="
          (total, range) =>
            `显示第 ${range[0]} 到第 ${range[1]} 条记录，总共 ${total} 条记录`
        "
        showQuickJumper
        showSizeChanger
        hide-on-single-page
        responsive
        :pageSizeOptions="['10', '20', '30', '50']"
    >
    </a-pagination>
  </div>
</template>
<script lang="ts" setup>
import {computed} from "vue";

const props = defineProps<{
  pageNum: number;
  pageSize: number
  count: number,
}>();

const emit = defineEmits<{
  (event: "update:pageNum", data: number): void;
  (event: "update:pageSize", data: number): void;
}>();

const current = computed({
  get() {
    return props.pageNum
  },
  set(value: number) {
    emit("update:pageNum", value)
  }
})

const size = computed({
  get() {
    return props.pageSize
  },
  set(value: number) {
    emit("update:pageSize", value)
  }
})

</script>


<style lang="scss" scoped>
.pagination {
  margin: $spacing-medium 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

</style>
